import React from "react";

const LeadContext = React.createContext({
  leadName: "",
  setLeadName: (_v) => {},
});

export function LeadProvider({ children }) {
  // carga inicial desde localStorage
  const [leadName, setLeadName] = React.useState(() => {
    try {
      return localStorage.getItem("leadName") || "";
    } catch {
      return "";
    }
  });

  // sincroniza cada cambio al storage
  React.useEffect(() => {
    try {
      if (leadName) localStorage.setItem("leadName", leadName);
      else localStorage.removeItem("leadName");
    } catch {}
  }, [leadName]);

  const value = React.useMemo(() => ({ leadName, setLeadName }), [leadName]);

  return <LeadContext.Provider value={value}>{children}</LeadContext.Provider>;
}

export function useLead() {
  return React.useContext(LeadContext);
}
